module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.actionData) ? _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [(_vm.requestType === 'rta') ? _c('section', {
    class: _vm.requestType + '-bg-colour'
  }, [_c('site-details', {
    attrs: {
      "row-data": _vm.actionData
    }
  })], 1) : _c('section', [(_vm.isActive(_vm.actionData)) ? _c('div', {
    class: _vm.requestType + '-bg-colour'
  }, [_c('request-workflow', {
    staticClass: "padded",
    attrs: {
      "row-data": _vm.actionData,
      "row-index": _vm.rowIndex,
      "close-dialog": _vm.closeDialog
    }
  }), _vm._v(" "), _c('hr')], 1) : _c('div', [_c('completed-request', {
    attrs: {
      "row-data": _vm.actionData,
      "row-index": _vm.rowIndex
    }
  })], 1)])]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc0dd48e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/requests/RequestDetails.vue
// module id = 1621
// module chunks = 0